import * as axios from "axios";

export const LOAD_TRANSLATED_RESOURCE = "/translated_resource/load";

export function loadResourceTranslations(id, selectedLanguage) {
  return function(dispatch) {
    return axios
      .get(`/api/mkp/v1/companies/${id}/translated_resources?language_code=${selectedLanguage}`)
      .then(res => {
        dispatch({
          type: LOAD_TRANSLATED_RESOURCE,
          data: res.data
        });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function translateResource(type, entity) {
  return function(dispatch, getState) {
    const {
      // eslint-disable-next-line
      app: { appLanguage },
      translatedResource: { data }
    } = getState()

    const tr = data.filter((e) => e.resource_type === type && e.resource_id === entity.id)[0]

    if (tr) {
      return Object.assign({}, entity, tr.translated_values)
    } else {
      return entity
    }
  };
}